import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Modal, Popconfirm, Row, Select, Switch, Tooltip, message } from 'antd';
import { AiOutlineStar } from 'react-icons/ai';
import { BsCheckSquare, BsRecordCircle, BsTrash } from 'react-icons/bs';
import { FaAlignLeft } from 'react-icons/fa';
import { MdShortText } from 'react-icons/md';
import { Question, QuestionType } from 'pages/khaosat/models';
import Quiz from '../typeQuestion/Quiz';
import { FormInstance } from 'antd/lib/form';
import ShortAnswer from 'pages/khaosat/typeQuestion/ShortAnswer';
import LongAnswer from 'pages/khaosat/typeQuestion/LongAnswer';
import RateAnswer from 'pages/khaosat/typeQuestion/RateAnswer';
import '../style.css';
import { useWatch } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import CollapseWrapper from 'base/ui/components/CustomCollapse';
import { IoDuplicate } from 'react-icons/io5';
import { cloneDeep } from 'lodash';
import { nanoid } from '@ant-design/pro-components';
import { surveyPresenter } from 'stores/root_store';
import CustomButton from 'base/ui/components/Button';
import { useTranslation } from 'react-i18next';

interface Props {
  form: FormInstance;
  item: Question;
  index: number;
  onDelete: (id: string) => void;
  sessionId?: string;
}

type RatingModel = {
  id?: string;
  title: number;
  score: number;
  desc: string;
};

type QuestionList = Question[] | undefined;

export const dataTypesQues = [
  {
    value: QuestionType.QUIZ,
    label: 'Trắc nghiệm',
    icon: <BsRecordCircle />,
  },
  {
    value: QuestionType.MULTI_CHOICE,
    label: 'Hộp kiểm',
    icon: <BsCheckSquare />,
  },
  {
    value: QuestionType.SHORT_ANSWER,
    label: 'Trả lời ngắn',
    icon: <MdShortText />,
  },
  {
    value: QuestionType.LONG_ANSWER,
    label: 'Trả lời đoạn',
    icon: <FaAlignLeft />,
  },
  {
    value: QuestionType.RATE,
    label: 'Đánh giá',
    icon: <AiOutlineStar />,
  },
];

const defaultRating: RatingModel[] = [
  {
    title: 1,
    score: 10,
    desc: 'terrible',
  },
  {
    title: 2,
    score: 20,
    desc: 'bad',
  },
  {
    title: 3,
    score: 30,
    desc: 'normal',
  },
  {
    title: 4,
    score: 40,
    desc: 'good',
  },
  {
    title: 5,
    score: 50,
    desc: 'wonderful',
  },
];

const QuestionItem = ({ form, item, index, onDelete, sessionId }: Props) => {
  const type = useWatch(['questions', index, 'type'], form) as QuestionType | undefined;

  const { t } = useTranslation();

  const [checkQuesApi, setCheckQuesApi] = useState(false)

  const handleQuestionTypeChange = (value: QuestionType, index: number) => {
    switch (value) {
      case QuestionType.SHORT_ANSWER:
      case QuestionType.QUIZ:
        form.setFieldValue(['questions', index, 'answers'], [undefined])
        break;
      case QuestionType.MULTI_CHOICE:
        form.setFieldValue(['questions', index, 'answers'], [undefined])
        break;
      case QuestionType.LONG_ANSWER:
      case QuestionType.RATE:
        form.setFieldValue(['questions', index, 'answers'], []);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    switch (type) {
      case QuestionType.RATE:
        const rate = form.getFieldValue(['questions', index, 'answers']);
        // kiểm tra rate, nếu không có id thì truyền id answers bên detail vào
        if (!rate[0]?.id) {
          form.setFieldValue(['questions', index, 'answers'], defaultRating);
        }
        break;
      default: {
        if (form.getFieldValue(['questions', index, 'answers', 0, 'desc'])) {
          form.setFieldValue(['questions', index, 'answers'], []);
        }
        break;
      }
    }
  }, [type]);


  // đang lỗi nên comment, có thể xóa đoạn này thừa
  // const [intitialValue, setIntitialValue] = useState<any>()
  // useEffect(() => {
  //   if (type === QuestionType.QUIZ || type === QuestionType.MULTI_CHOICE) {
  //     form.setFieldValue(['questions', index, 'answers'], [undefined])
  //   }
  // }, [type])

  return (
    <CollapseWrapper
      customClassName="!mt-3"
      title={
        form.getFieldValue(['questions', index, 'title'])
          ? `Câu hỏi ${index + 1}: ` + form.getFieldValue(['questions', index, 'title'])
          : 'Câu hỏi ' + (index + 1)
      }
    >
      {/* title question item */}
      <div className="bg-white rounded-lg relative py-4 md:px-4 pb-0flex-1 ">
        <Form.Item
          className="m-0 p-0 mb-4"
          wrapperCol={{ span: 10 }}
          name={['questions', index, 'title']}
          labelCol={{ span: 2 }}
          label="Câu hỏi"
          rules={[{ required: true }]}
        >
          <Input placeholder={`Nhập câu hỏi`} />
        </Form.Item>
        <Row>
          <Col xs={24} md={16}>
            <Form.List
              initialValue={[undefined]}
              name={['questions', index, 'answers']}>
              {(fields, { add, remove }) => {
                return (
                  <>
                    {type === QuestionType.QUIZ || type === QuestionType.MULTI_CHOICE ? (
                      <>
                        {fields.map(({ key, name, ...restField }, idx) => (
                          // component trắc nghiệm
                          <Quiz
                            form={form}
                            key={idx}
                            name={item.title}
                            restField={restField}
                            index={idx}
                            remove={remove}
                            questionIdx={index}
                            sessionId={sessionId}
                            addItem={add}
                          />
                        ))}
                        {/* <Form.Item
                          className="m-0 p-0 mb-4"
                          wrapperCol={{ span: 8 }}
                          colon={false}
                          labelCol={{ span: 3 }}
                          label=" "
                        >
                          <Button size="small" type="dashed" onClick={() => {
                            add()
                          }} block icon={<PlusOutlined />}>
                            Thêm câu trả lời
                          </Button>
                        </Form.Item> */}
                      </>
                    ) : null}
                    {type === QuestionType.SHORT_ANSWER ? <ShortAnswer /> : null}
                    {type === QuestionType.LONG_ANSWER ? <LongAnswer /> : null}
                    {type === QuestionType.RATE ? (
                      <Form.List name={[]}>
                        {(fieldsRate) => {
                          return (
                            <>
                              {fieldsRate.map(({ key, name, ...restField }, idx) => (
                                <RateAnswer
                                  form={form}
                                  key={idx}
                                  questionIdx={index}
                                  index={idx}
                                  restField={restField}
                                  sessionId={sessionId}
                                />
                              ))}
                            </>
                          );
                        }}
                      </Form.List>
                    ) : null}
                  </>
                );
              }}
            </Form.List>
          </Col>
          <Col xs={0} md={1}>
            <div className="bg-gray-300 h-full w-[2px] rounded mx-auto"></div>
          </Col>
          <Col xs={24} flex="auto">
            {/* loại câu hỏi */}
            <Form.Item
              labelCol={{ span: 6 }}
              labelAlign="left"
              name={['questions', index, 'type']}
              label="Loại câu hỏi"
              wrapperCol={{ span: 12 }}
              className="!mb-3"
            >
              <Select onChange={(value) => handleQuestionTypeChange(value, index)}>
                {dataTypesQues.map((item) => {
                  return (
                    <Select.Option key={item.value} value={item.value}>
                      <div className="flex gap-4 items-center">
                        <div>{item.icon}</div>
                        <div>{item.label}</div>
                      </div>
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            {/* Bắt buộc */}
            <div className="flex items-center gap-4">
              <Form.Item
                className="!m-0 p-0 [&_.ant-switch_.ant-switch-inner]:bg-gray-400 [&_.ant-switch.ant-switch-checked_.ant-switch-inner]:bg-primary"
                wrapperCol={{ span: 12 }}
                labelCol={{ span: 0 }}
                label="Bắt buộc"
                name={['questions', index, 'required']}
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              {/* Chấm điểm */}
              {(type === QuestionType.MULTI_CHOICE || type === QuestionType.QUIZ || type === QuestionType.RATE) && (
                <Form.Item
                  className="!m-0 p-0 [&_.ant-switch_.ant-switch-inner]:bg-gray-400 [&_.ant-switch.ant-switch-checked_.ant-switch-inner]:bg-primary"
                  wrapperCol={{ span: 12 }}
                  labelCol={{ span: 0 }}
                  name={['questions', index, 'hasPoint']}
                  label="Chấm điểm"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              )}
              {/* Trash */}
              <div className="h-[40px] w-[2px] bg-gray-300 rounded"></div>
              <Form.Item className="!m-0" wrapperCol={{ span: 12 }}>
                {/* <Popconfirm
                  title="Xóa"
                  description={(checkQuesApi ? 'Câu hỏi đã được khách hàng trả lời.' : '') + " Bạn có chắc muốn xóa câu hỏi này?"}
                  onConfirm={async () => {
                    onDelete(item.id);
                  }}
                  okButtonProps={{
                    style: {
                      background: 'red',
                    },
                  }}
                  placement="topRight"
                  okText="Yes"
                  cancelText="No"
                > */}
                <BsTrash onClick={async () => {
                  const result = await surveyPresenter.deleteQuestionInSurvey(item.id)
                  if (result.data) {
                    message.warning('Câu hỏi đã được khách hàng trả lời')
                  }
                  setCheckQuesApi(result.data)
                  const instance = Modal.confirm({
                    title: "Xóa",
                    content: checkQuesApi ? 'Câu hỏi đã được khách hàng trả lời. Bạn có chắc muốn xóa câu hỏi này?' : 'Bạn có chắc muốn xóa câu hỏi này?',
                    onOk: async () => {
                      onDelete(item.id)
                    },
                    footer: (
                      <div className="flex gap-4 justify-end mt-4">
                        <CustomButton
                          onClick={() => {
                            instance.destroy();
                          }}
                        >
                          {t('btn.cancel')}
                        </CustomButton>
                        <CustomButton
                          className='!text-white hover:bg-[#fff] '
                          color='#209de0'
                          onClick={() => {
                            onDelete(item.id)
                            instance.destroy();
                          }}
                        >
                          {t('btn.continue')}
                        </CustomButton>
                      </div>
                    ),

                  })
                }}
                  className="text-xl text-red-500 cursor-pointer" />
                {/* </Popconfirm> */}
              </Form.Item>
              <Form.Item name={['questions', index, 'id']} hidden />
              {/* duplicate */}
              <div onClick={() => {
                // lấy câu hỏi hiện tại để duplicate
                const currentQues = form.getFieldValue(['questions', index])
                const currentQuesTemp = cloneDeep(currentQues)
                Object.assign(currentQuesTemp, { id: nanoid() })
                // tạo 1 mảng lưu form câu hỏi để thay đổi form ques
                const currentArrQues = cloneDeep(form.getFieldValue('questions') as QuestionList)
                const arrayQues = cloneDeep(currentArrQues)
                // insert item được duplicate vào trong form
                arrayQues?.splice(index, 0, currentQuesTemp)
                // cập nhật lại form sau khi duplicate
                form.setFieldValue('questions', arrayQues)

                // console.log('arrayQues', arrayQues);
                // console.log('aaaaaaaaaaaa', form.getFieldValue(['questions', index]))
                // console.log('bbbbbbbbbbbb', currentQues)
                // console.log('cccccccccccccc', form.getFieldsValue());
              }}>
                <Tooltip title="Copy câu hỏi">
                  <IoDuplicate className='text-xl text-yellow-400 cursor-pointer' />
                </Tooltip>
              </div>

            </div>
          </Col>
        </Row>
      </div>
    </CollapseWrapper>
  );
};

export default QuestionItem;
